const productDetailLink = (item, type) => (
  `/product/${type ?? item.itemIdType}/${(type ?? item.itemIdType) === 'ean' ? item.ean : `${item.merchantUuid}/${item.external_id}`}`
)

export default productDetailLink
